import axios from 'axios';

export default class FalhaRetornosService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async listarFalhasRetorno(params) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'titulos/falha-retornos',
                {
                    params: params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async listarApresentantes() {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'apresentantes',
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return { data: response.data, status: response.status };
        } catch (error) {
            throw error?.response;
        }
    }

    async reprocessarRetornoComDados(dadosCompletos) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/falha-retornos/${dadosCompletos.id}/reprocessar-com-dados`,
                dadosCompletos,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async ignorarRetorno(id) {
        try {
            const response = await axios.patch(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/falha-retornos/${id}/ignorar`,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async buscarDetalhes(id) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/falha-retornos/${id}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async adicionarHistoricoStatus(dadosHistorico) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulos/historico',
                dadosHistorico,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async atualizarHistoricoStatus(idHistorico, dadosHistorico) {
        try {
            const response = await axios.put(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/historico/${idHistorico}`,
                dadosHistorico,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async buscarHistoricoStatus(idHistorico) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API +
                    `titulos/historico/${idHistorico}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
}
